(function () {
    const CAMPAIGN_PREFIX = 'wc';
    const TEST_ID = `${CAMPAIGN_PREFIX}-pp-02`;
  
    waitFor(() => {
      return document.querySelector('.review-widget');
    })
      .then(init)
      .catch((err) => console.error('when stopped: by timeout', TEST_ID, err));
  
    function init() {
      const targetNode = document.querySelector('.review-widget').parentNode;
  
      targetNode && targetNode.insertAdjacentHTML('afterend', getHTML(true));
    }
  
    function getHTML() {
      return `
      <div class="${TEST_ID}__container">
        <p>De Nagelverzorgingspen is jouw ultieme dagelijkse oplossing voor het behouden van gezonde, mooie nagels.</p>
        <p>
          Geformuleerd met <span class="text-accent">Tea Tree-Olie, Aloë Vera, Vitamine C, Pepermunt</span> en <span class="text-accent">Kastanje-Extract</span>
        </p>
  
        <ul class="advantages-l">
          <li class="advantages-l-i">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="13.23" r="10" stroke="#72A6A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 13.48C8 13.48 6.5 14.539 6.5 16.48V21.372M15 13.48C16 13.48 17.5 14.539 17.5 16.48V21.23M12 7.47998C13.6569 7.47998 15 8.82313 15 10.48V16.48C15 18.1368 13.6569 19.48 12 19.48C10.3431 19.48 9 18.1368 9 16.48V10.48C9 8.82313 10.3431 7.47998 12 7.47998Z" stroke="#72A6A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="text-accent">Behandelt nagelschimmelinfecties</span>
          </li>
          <li class="advantages-l-i">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.17902 22.8371L1.89788 19.556C1.25486 18.9131 0.893505 18.0412 0.893311 17.132V9.97998C0.893311 9.52532 1.07392 9.08928 1.39541 8.76779C1.7169 8.4463 2.15294 8.26569 2.6076 8.26569C3.06225 8.26569 3.49829 8.4463 3.81978 8.76779C4.14127 9.08928 4.32188 9.52532 4.32188 9.97998V15.1228M18.8213 22.8371L22.1025 19.556C22.7449 18.9129 23.1056 18.041 23.1053 17.132V9.97998C23.1053 9.52532 22.9247 9.08928 22.6032 8.76779C22.2817 8.4463 21.8457 8.26569 21.391 8.26569C20.9364 8.26569 20.5003 8.4463 20.1788 8.76779C19.8574 9.08928 19.6767 9.52532 19.6767 9.97998V15.1228M5.89045 18.2565L4.67845 17.0445C4.36618 16.7212 4.19339 16.2882 4.1973 15.8387C4.2012 15.3892 4.38149 14.9593 4.69934 14.6414C5.01718 14.3236 5.44714 14.1433 5.89662 14.1394C6.3461 14.1355 6.77914 14.3083 7.10245 14.6205L9.31903 16.8371C9.96142 17.4802 10.3221 18.3521 10.3219 19.2611V22.8371M18.1099 18.2565L19.3219 17.0445C19.6342 16.7212 19.8069 16.2882 19.803 15.8387C19.7991 15.3892 19.6188 14.9593 19.301 14.6414C18.9832 14.3236 18.5532 14.1433 18.1037 14.1394C17.6542 14.1355 17.2212 14.3083 16.8979 14.6205L14.6813 16.8371C14.0389 17.4802 13.6782 18.3521 13.6785 19.2611V22.8371M15.4647 9.83598C15.4647 7.90398 12.0362 3.12283 12.0362 3.12283C12.0362 3.12283 8.6076 7.90569 8.6076 9.83598C8.6076 10.7823 8.96931 11.6925 9.61217 12.3628C10.255 13.0314 11.1276 13.4085 12.0362 13.4085C12.9447 13.4085 13.819 13.0314 14.4619 12.3628C15.1089 11.681 15.4682 10.7759 15.4647 9.83598Z" stroke="#72A6A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="text-accent">Hydrateert en regenereert</span>
          </li>
          <li class="advantages-l-i">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_230_15764)">
              <path d="M3.5 16.48H3M3.5 16.48C3.5 17.4082 3.13125 18.2985 2.47487 18.9549C1.8185 19.6112 0.928258 19.98 0 19.98M3.5 16.48H14.5V16.98C14.5 17.7756 14.1839 18.5387 13.6213 19.1013C13.0587 19.6639 12.2956 19.98 11.5 19.98H8H15L18.824 18.387C19.4683 18.1188 20.1591 17.9805 20.857 17.98H21C21.663 17.98 22.2989 18.2434 22.7678 18.7122C23.2366 19.1811 23.5 19.8169 23.5 20.48L14 24.48H0" stroke="#72A6A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 4.97998V9.47998M9.75001 7.22998H14.25M18 5.72998C18.0032 7.47642 17.4103 9.17166 16.3193 10.5354C15.2283 11.8991 13.7046 12.8497 12 13.23C10.2955 12.8497 8.77173 11.8991 7.68074 10.5354C6.58974 9.17166 5.99682 7.47642 6.00001 5.72998V3.47998C6.00001 3.08216 6.15805 2.70062 6.43935 2.41932C6.72066 2.13802 7.10219 1.97998 7.50001 1.97998H16.5C16.8978 1.97998 17.2794 2.13802 17.5607 2.41932C17.842 2.70062 18 3.08216 18 3.47998V5.72998Z" stroke="#72A6A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
              <clipPath id="clip0_230_15764">
              <rect width="24" height="24" fill="white" transform="translate(0 0.97998)"/>
              </clipPath>
              </defs>
            </svg>
            <span class="text-accent">Beschermt en versterkt de nagels</span>
          </li>
        </ul>
      </div>`;
    }
  
    function waitFor(conditionFn, stopAfter = 7000) {
      return new Promise((resolve, reject) => {
        let stopByTimeout = false;
        let value;
  
        window.setTimeout(() => {
          stopByTimeout = true;
        }, stopAfter);
  
        (function _innerWaitFor() {
          if (stopByTimeout) {
            reject(Error('when stopped: by timeout'));
            return;
          }
          try {
            value = conditionFn();
          } catch (e) {
            /* silent */
          }
          value ? resolve(value) : window.setTimeout(_innerWaitFor, 50);
        })();
      });
    }
  })();
  //# sourceURL=url://weConvert/wc-pp-02/variants/variant-v1/js.js